export function NewParticipantInTournament(idTournament,idTeam){
    return {
        "team_id": idTeam,
        "tournament_id": idTournament
    }
}